import type { ReactNode } from 'react';

// `app/24/Padding.js` — the page's one horizontal rhythm, applied per section.
export default function Padding({ children }: { children: ReactNode }) {
  return (
    <div className="size-full px-4 sm:px-6 md:px-16 lg:px-32 xl:px-64">
      {children}
    </div>
  );
}
